import CardIconItem from "./CardIconItem";

import "./CardIcon.css";

const CardIconContainer = (props) => {
	return (
		<div className="d-flex justify-content-evenly flex-wrap mt-5">
			{props.listItems.map((data, key) => (
				<CardIconItem key={key} name={data.name} icon={data.icon} colorIcon={data.color} />
			))}
		</div>
	);
};

export default CardIconContainer;
